/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovU291cmNlL2VTb2Z0Q2VyZWFsLkFQSS9lU29mdENlcmVhbC5VSS9zcmMvYXBwL2NsaWVudGVzL2NsaWVudGVzLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1NvdXJjZS9lU29mdENlcmVhbC5BUEkvZVNvZnRDZXJlYWwuVUkvc3JjL2FwcC9jbGllbnRlcy9jbGllbnRlcy5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/$$_gendir/app/clientes/clientes.component.scss.shim.ngstyle.ts